export default "https://d1e6s5z4lzmgxx.cloudfront.net/e6c6b85e-6085-403a-93bd-a279ec1d3907/images/clips-icon.svg?1f1e6d491e2a92306193b5208a73a8f5";